import { ExchangeRateName, SystemCurrency } from '@okletsplay/core';
import { ExchangeRateDto } from 'app/interfaces/dto';

/**
 * Note: Currencies in `ExchangeRateDto.name` from and to are flipped on server side.
 */
export const selectExchangeRate = (
  exchangeRates: ExchangeRateDto[],
  rateName: ExchangeRateName
): number => {
  return exchangeRates.find((exchangeRate) => exchangeRate.name === rateName)?.rate ?? 0;
};

/**
 * Note: Currencies in `ExchangeRateDto.name` from and to are flipped on server side.
 */
export const selectToFiatExchangeRate = (
  exchangeRates: ExchangeRateDto[],
  from: SystemCurrency
) => {
  return (
    exchangeRates.find(
      (exchangeRate) => exchangeRate.name === 'USD' + from || exchangeRate.name === from + 'USD'
    )?.rate ?? 0
  );
};
